export class RoutingPath {
  public static appRouting = {
    components: {
      dashboard: {
        path: 'tablero',
        breadcrumb: 'tablero',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Inicio'
          },
          affiliation: {
            path: 'afiliacion',
            breadcrumb: 'Afiliación'
          },
          retreat: {
            path: 'retiro',
            breadcrumb: 'Retiro'
          }
        }
      },
      business_information: {
        path: 'informacion-empresas',
        breadcrumb: 'Información de Empresas',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Información empresa'
          }
        }
      },
      invidivual_affiliation: {
        path: 'afiliacion-individual',
        breadcrumb: 'Afiliación individual',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Afiliación individual'
          },
          user_validation: {
            path: 'validar-usuario',
            breadcrumb: 'Validar usuario'
          },
          affiliation_form: {
            path: 'formulario-afiliacion',
            breadcrumb: 'Formulario afiliación'
          },
          success_affiliation: {
            path: 'afiliacion-exitosa',
            breadcrumb: 'Afiliación exitosa'
          },
          error_affiliation: {
            path: 'error-afiliacion',
            breadcrumb: 'Error de afiliación'
          }
        }
      },
      mass_affiliation: {
        path: 'afiliacion-masiva',
        breadcrumb: 'Afiliación masiva',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Afiliación masiva'
          },
          file_upload: {
            path: 'cargar-archivo',
            breadcrumb: 'Cargar archivo'
          },
          file_validation_result: {
            path: 'resultado-validacion-archivo',
            breadcrumb: 'Resultado validación archivo'
          },
          affiliation_result: {
            path: 'resultado-afiliacion',
            breadcrumb: 'Resultado Afiliación'
          }
        }
      },
      beneficiary_removal:{
        path: 'retiro-beneficiario',
        breadcrumb: 'Afiliacion de beneficiario',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Afiliación beneficiario'
          },
          beneficiary_form: {
            path: 'nuevo/:docuemntNumber',
            breadcrumb: 'retiro beneficiario'
          },
          success: {
            path: 'retiro-exitoso',
            breadcrumb: 'Afiliación exitosa'
          },
          error_retreat: {
            path: 'retiro-error',
            breadcrumb: 'Afiliación error'
          },
          beneficiary_edit_form: {
            path: 'formulario-retiro-editar/:idRequest',
            pathRelative: 'formulario-retiro-editar',
            breadcrumb: 'retiro beneficiario'
          },
        }
      },
      acreditacion_cuota:{
        path: 'acreditacion-cuota',
        breadcrumb: 'Acreditacion cuota monetaria',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Acreditacion cuota monetaria'
          },
          acreditacion_cuota_new_form: {
            path: 'nuevo/:documentNumber',
            pathRelative: 'nuevo',
            breadcrumb: 'Acreditacion cuta monetaria'
          },
          success: {
            path: 'solicitud-exitosa',
            breadcrumb: 'Acreditacion cuota monetaria exitosa'
          },
          error_retreat: {
            path: 'solicitud-error',
            breadcrumb: 'Acreditacion cuota monetaria error'
          },
          acreditaion_cuta_edit_form: {
            path: 'formulario-acreditacion-editar/:idRequest',
            pathRelative: 'formulario-acreditacion-editar',
            breadcrumb: 'acreditacion beneficiario'
          },
        }
      },
      discapacidad:{
        path: 'discapacidad',
        breadcrumb: 'Discapacidad',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Discapacidad'
          },
          discapacidad_new_form: {
            path: 'nuevo/:documentNumber',
            pathRelative: 'nuevo',
            breadcrumb: 'Acreditacion cuta monetaria'
          },
          success: {
            path: 'solicitud-exitosa',
            breadcrumb: 'Discapacidad exitosa'
          },
          error_retreat: {
            path: 'solicitud-error',
            breadcrumb: 'Discapacidad error'
          },
          discapacidad_edit_form: {
            path: 'formulario-acreditacion-editar/:idRequest',
            pathRelative: 'formulario-acreditacion-editar',
            breadcrumb: 'acreditacion beneficiario'
          },
        }
      },
      afiliate_beneficiary:{
        path: 'afiliacion-beneficiario',
        breadcrumb: 'Afiliacion de beneficiario',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Afiliación beneficiario'
          },
          beneficiary_form: {
            path: 'formulario-afiliacion',
            breadcrumb: 'afiliacion beneficiario'
          },
          success: {
            path: 'afiliacion-exitosa',
            breadcrumb: 'Afiliación exitosa'
          },
          error_retreat: {
            path: 'afiliacion-error',
            breadcrumb: 'Afiliación error'
          },
          beneficiary_edit_form: {
            path: 'formulario-afiliacion-editar/:idRequest',
            pathRelative: 'formulario-afiliacion-editar',
            breadcrumb: 'afiliacion beneficiario'
          },
        }
      },
      individual_retreat: {
        path: 'retiro-individual',
        breadcrumb: 'Retiro individual',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Retiro individual'
          },
          user_validation: {
            path: 'validar-usuario',
            breadcrumb: 'Validar usuario'
          },
          retreat_form: {
            path: 'formulario-retiro',
            breadcrumb: 'Formulario afiliación'
          },
          perfil_worker:{
            path: 'perfil-trabajador',
            breadcrumb: 'Perfil del Trabajador'
          },
          success_retreat: {
            path: 'afiliacion-exitosa',
            breadcrumb: 'Afiliación exitosa'
          },
          error_retreat: {
            path: 'error',
            breadcrumb: 'Error en validación'
          },
          list_request: {
            path: 'list-request',
            breadcrumb: 'Solicitudes'

          },
          retreat_form_edit: {
            path: 'formulario-retiro/editar/solicitud/:idRequest',
            pathRelative: 'formulario-retiro/editar/solicitud',
            breadcrumb: 'Editar Solicitud'
          }
        }
      },
      mass_retreat: {
        path: 'retiro-masivo',
        breadcrumb: 'Retiro masivo',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Retiro masivo'
          },
          file_upload: {
            path: 'cargar-archivo',
            breadcrumb: 'Cargar archivo'
          },
          file_validation_result: {
            path: 'resultado-validacion-archivo',
            breadcrumb: 'Resultado validación archivo'
          },
          retreat_result: {
            path: 'resultado-retiro',
            breadcrumb: 'Resultado Retiro'
          }
        }
      },

      workers_information: {
        path: 'informacion-trabajador',
        breadcrumb: 'Información trabajador',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Información trabajador'
          },
          consult_worker: {
            path: 'consultar-trabajador',
            breadcrumb: 'Consultar trabajador'
          },
          query_filter: {
            path: 'filtro-consulta',
            breadcrumb: 'Filtro de consulta'
          },
          query_result: {
            path: 'resultado-consulta',
            breadcrumb: 'Resultado consulta trabajador'
          },
          consultation_demografic: {
              path: 'consulta-demografica',
              breadcrumb: 'Consulta masiva'
          },
          affiliation_form: {
            path: 'formulario-afiliacion',
            breadcrumb: 'Formulario afiliación'
          },
          success: {
            path: 'afiliacion-exitosa',
            breadcrumb: 'Afiliación exitosa'
          },
          error_retreat: {
            path: 'afiliacion-error',
            breadcrumb: 'Afiliación error'
          },
          civil_status_change: {
            path: 'cambio-estado-civil',
            breadcrumb: 'Cambio estado civil',
            children: {
              new_civil_status_change: {
                path: 'nueva-solicitud',
                breadcrumb: 'Nueva solicitud'
              },
              update_civil_status_change: {
                path: 'actualizar-solicitud/:idRequest',
                pathRelative: 'actualizar-solicitud',
                breadcrumb: 'Actualizar solicitud'
              },
              success: {
                path: 'solicitud-exitosa',
                breadcrumb: 'Solicitud exitosa'
              },
              error_retreat: {
                path: 'solicitud-error',
                breadcrumb: 'Solicitud error'
              },
            }
          },
        }
      },
      user: {
        path: 'usuario',
        breadcrumb: 'Usuario',
        pages: {
          change_password: {
            path: 'cambiar-contrasena',
            breadcrumb: 'Cambiar contraseña'
          }
        }
      },
      certificates: {
        path: 'certificado',
        breadcrumb: 'Certificado',
        pages: {
          company_affiliation_certificate: {
            path: 'certificado-afiliacion-empresa',
            breadcrumb: 'certificado afiliación empresa'
          },
          consult_worker: {
            path: 'consultar-trabajador',
            breadcrumb: 'Consultar trabajador'
          },
          worker_affiliation_certificate: {
            path: 'certificado-afiliacion-trabajador',
            id: 'trabajador',
            breadcrumb: 'Certificado afiliación trabajador'
          },
          search_monetary_fee: {
            path: 'consulta-cuota-monetaria',
            id: 'cuotam',
            breadcrumb: ''
          },
          monetary_fee: {
            path: 'cuota-monetaria',
            breadcrumb: ''
          }
        }
      }, affiliates_process: {
        path: 'afiliaciones-proceso',
        breadcrumb: 'Afiliaciones en proceso',
        pages: {
          home: {
            path: 'inicio',
            breadcrumb: 'Afiliaciones'
          },
          detail: {
            path: 'detalle',
            breadcrumb: 'Detalle afiliación'
          }
        }
      }, pqrs: {
        path: 'pqrs',
        breadcrumb: 'PQRS',
        pages: {
          notiFss: {
            path: 'notificacion-fss',
            breadcrumb: 'Notificaciones'
          },
          pqr: {
            path: 'inicio',
            breadcrumb: 'inicio'
          },
          responses: {
            path: 'respuestas',
            breadcrumb: 'PQR'
          }, send: {
            path: 'envio-exitoso',
            breadcrumb: 'PQR'
          }, sendFailed: {
            path: 'respuesta-fallida',
            breadcrumb: 'PQR'
          }
        }
      }, mass_queries: {
        path: 'consultas-masivas',
        breadcrumb: 'Consultas masivas',
        pages: {
            home: {
                path: 'inicio',
                breadcrumb: 'Consultas'
            },
            detail: {
                path: 'detalle',
                breadcrumb: 'Detalle consulta'
            },
            response: {
                path: 'respuesta',
                breadcrumb: 'Respuesta consulta'
            }
        }
      },
      subsidy: {
        path: 'subsidio',
        breadcrumb: 'Subsidio',
        pages: {
          subsidy_monetary_fee_request: {
            path: 'cuota-monetaria/pac/:id',
            pathRelative: 'cuota-monetaria/pac',
            breadcrumb: 'Solicitud subsidio familiar'
          },
          subsidy_monetary_fee_request_find: {
            path: 'cuota-monetaria/devolucion/:settled',
            breadcrumb: 'Solicitud subsidio familiar'
          },
          subsidy_monetary_fee_request_response_failed: {
            path: 'cuota-monetaria/solicitud/fallida',
            breadcrumb: 'Solicitud subsidio familiar'
          },
          subsidy_monetary_fee_request_response_successful: {
            path: 'cuota-monetaria/solicitud/:id',
            pathRelative: 'cuota-monetaria/solicitud',
            breadcrumb: 'Solicitud subsidio familiar'
          },
          notifications: {
            path: 'notificaciones',
            breadcrumb: 'Notificaciones'
          }
        }
      },
      disaffiliate_query: {
        path: 'consulta-retiros',
        breadcrumb: 'Consulta retiros',
        pages: {
          query_request: {
            path: 'consultar-solicitudes',
            breadcrumb: 'Consultar solicitudes'
          },
          detail: {
            path: 'detalle',
            breadcrumb: 'Detalle consulta'
          }
        }
      },
      affiliate_query: {
        path: 'consulta-afiliaciones',
        breadcrumb: 'Consulta afiliaciones',
        pages: {
          query_request: {
            path: 'consultar-solicitudes',
            breadcrumb: 'Consultar afiliaciones'
          },
          detail: {
            path: 'detalle',
            breadcrumb: 'Detalle consulta'
          }
        }
      },
    }
  };
}
